document.addEventListener('DOMContentLoaded', function () {
    const readBtn = document.getElementById('readArticle');
    const articleContent = document.getElementById('articleContent');
    let iconSpan = null;
    if (readBtn) {
        // Seleziona lo span dell'icona all'interno del pulsante
        iconSpan = readBtn.querySelector('.material-symbols-outlined');
    }
    let synth = window.speechSynthesis;
    let utterance;

    if (readBtn && iconSpan && articleContent) {
        readBtn.addEventListener('click', function () {
            // Se sta già leggendo, interrompi e ripristina icona/stato
            if (synth.speaking) {
                synth.cancel();
                readBtn.classList.remove('active');
                iconSpan.textContent = 'select_to_speak';
                return;
            }
            // Recupera il testo da leggere
            const text = articleContent.innerText;
            if (text.trim().length === 0) return;

            utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = 'it-IT';

            // Cambia icona e stato quando inizia la lettura
            utterance.onstart = function () {
                readBtn.classList.add('active');
                iconSpan.textContent = 'stop_circle';
            };
            // Ripristina icona e stato quando termina/interrompe
            utterance.onend = function () {
                readBtn.classList.remove('active');
                iconSpan.textContent = 'select_to_speak';
            };
            utterance.onerror = function () {
                readBtn.classList.remove('active');
                iconSpan.textContent = 'select_to_speak';
            };

            synth.speak(utterance);
        });
    }
});

window.addEventListener('beforeunload', function () {
    window.speechSynthesis.cancel();
});